export default "__VITE_ASSET__CUs2sycD__"